/**
 * Beheer (sessie 70, W5-3): één rustige lijst met alle beheerschermen,
 * een woord per regel onder een kopje. Een medewerker ziet alleen wat hij
 * mag openen; de rest staat er voor beheerders.
 *
 * Tot sessie 70 opende `/beheer` de instellingen. Die staan nu op
 * `/beheer/instellingen`; een oud adres met een zoekstring of anker
 * (`/beheer?google=verbonden`, de terugsprong van Google) gaat daar
 * ongewijzigd heen.
 */
import { Link, Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "@/lib/auth-store";

import { BEHEER_GROEPEN } from "./schermen";
import "./beheer.css";

export function WerkplekV6BeheerLijst() {
  const { search, hash } = useLocation();
  const beheerder = useAuthStore((s) => s.gebruiker?.rol === "admin");

  if (search || hash) return <Navigate to={`/beheer/instellingen${search}${hash}`} replace />;

  const groepen = BEHEER_GROEPEN.map((g) => ({
    ...g,
    schermen: g.schermen.filter((s) => beheerder || !s.alleenBeheer),
  })).filter((g) => g.schermen.length > 0);

  return (
    <section className="v6-vlak v6-beheer" aria-label="Beheer">
      <header className="v6-bh-kop">
        <h1>Beheer</h1>
      </header>
      <div className="v6-bh-scrol">
        <div className="v6-bh-groepen">
          {groepen.map((groep) => (
            <nav key={groep.kop} className="v6-bh-groep" aria-label={groep.kop}>
              <h2>{groep.kop}</h2>
              <ul>
                {groep.schermen.map((s) => (
                  <li key={s.naar}>
                    <Link to={s.naar}>{s.woord}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>
    </section>
  );
}
